import { render, staticRenderFns } from "./MRegister.vue?vue&type=template&id=035ba874&scoped=true&"
import script from "./MRegister.vue?vue&type=script&lang=ts&"
export * from "./MRegister.vue?vue&type=script&lang=ts&"
import style0 from "./MRegister.vue?vue&type=style&index=0&id=035ba874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ba874",
  null
  
)

export default component.exports